import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Container, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { Academy } from 'types/traiwiss'
import RouteContainer from 'src/components/App/RouteContainer'

const AcademyList = React.lazy(() => loadComponent('traiwiss', 'AcademyList'))

const StyledButton = styled(Button)`
    float: right;
`
const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`
const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function AcademyIndexRoute() {
    const navigate = useNavigate()

    const canCreate = usePermission('traiwiss.academy.create', {})
    const canDelete = usePermission('traiwiss.academy.delete', {})

    const onSelect = useCallback(
        (academy: Academy) => {
            navigate(academy._id)
        },
        [navigate],
    )

    const onCreate = useCallback(() => {
        navigate('/academies/new')
    }, [navigate])

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Akademien</StyledHeadingText>
                {canCreate && (
                    <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                        neu
                    </StyledButton>
                )}
            </StyledHeaderContainer>
            <AcademyList onSelect={onSelect} canDelete={canDelete} />
        </RouteContainer>
    )
}
